import React from "react";
// Updated import for createRoot
import * as ReactDOMClient from 'react-dom/client'; 
import { App } from "./components/App";
import "./styles/logo.scss"; // Import logo styles
// No longer need to import loadConfig
// import { loadConfig } from "./utils/config"; 

// Config is loaded automatically via import in config.ts
// loadConfig(); // Remove this call

// --- Register Service Worker ---
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Use URL object as required by Parcel
    navigator.serviceWorker.register(
        new URL('./sw.js', import.meta.url) // Use relative path and import.meta.url
    ) 
      .then(registration => {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
      })
      .catch(error => {
        console.log('ServiceWorker registration failed: ', error);
      });
  });
}
// -----------------------------

// Proceed with rendering after config is loaded
const container = document.getElementById("app");
// Check if container exists before creating root
if (container) { 
  const root = ReactDOMClient.createRoot(container); // Use the new import
  root.render(<App />);
} else {
  console.error("Failed to find the root element with ID 'app'");
}
